// extracted by mini-css-extract-plugin
export default {"mainAsset":"CampaignHeroAssetsSkeleton_mainAsset__0rUU0","pickerAsset":"CampaignHeroAssetsSkeleton_pickerAsset__k6oFu"};